import React from "react";
import Accordion from "react-bootstrap/Accordion";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Faq.css'
import { ClientePageShell } from "../../../components/ClientePageShell";

const Faq = () => {

    return (
        <ClientePageShell
            className="faq-page"
            eyebrow="Suporte"
            title="FAQ"
            subtitle="Respostas rápidas para dúvidas operacionais frequentes da área do cliente."
        >
            <section className="cliente-page-panel faq-panel">
                <Accordion defaultActiveKey="1" className="faq-accordion">
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Em quanto tempo o saque cairá na minha conta?</Accordion.Header>
                        <Accordion.Body>
                            O prazo para efetivação dos saques é de 7 dias úteis.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Por que a minha cota é parcialmente reduzida todo mês?</Accordion.Header>
                        <Accordion.Body>
                            Porque os descontos das taxas de performance (20% sobre os lucros) e administração (0,16% sobre o capital total), são feitos mensalmente e descontados em cotas. A taxa de performance só existe quando há fechamento de mês com lucros. Acesse a aba “Ativos” para acompanhar leituras e contexto dos ativos da carteira.
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </section>
        </ClientePageShell>
    );
};

export default Faq;
